module.exports = function (Chart) {
  Chart.elements.Image = Chart.Element.extend({
    tooltipPosition(){
      return {
        x: this._model.x + this._model.width / 2,
        y: this._model.y + this._model.height / 4 * 3
      }
    },

    inRange(){
      return true;
    },

    getCenterPoint(){
      var vm = this._view;
      return {
        x: this._model.x + this._model.width / 2,
        y: this._model.y + this._model.height / 2
      }
    },

    draw(){
      var ctx = this._chart.ctx,
        vm = this._view;

      ctx.drawImage(vm.img, vm.x, vm.y, vm.width, vm.height);
    }

  })
};
